module.exports = __webpack_public_path__ + "img/189.e50cc29d.jpg";